(() => {
  class PolicyTabs extends HTMLElement {
    constructor() {
      super();

      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.pendingTab = null;
      this.transitionTimer = null;
    }

    connectedCallback() {
      if (this.dataset.initialized === "true") {
        return;
      }

      this.dataset.initialized = "true";
      this.tabs = [...this.querySelectorAll("[data-policy-tab]")];
      this.panels = [...this.querySelectorAll("[data-policy-panel]")];
      this.content = this.querySelector("[data-policy-content]");
      this.tablist = this.querySelector('[role="tablist"]');

      if (!this.tabs.length || !this.panels.length || !this.content) {
        return;
      }

      this.classList.add("is-enhanced");
      this.addEventListener("click", this.handleClick);
      this.addEventListener("keydown", this.handleKeydown);
      document.addEventListener("shopify:block:select", this.handleBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.handleClick);
      this.removeEventListener("keydown", this.handleKeydown);
      document.removeEventListener("shopify:block:select", this.handleBlockSelect);
      window.clearTimeout(this.transitionTimer);
      delete this.dataset.initialized;
    }

    handleClick(event) {
      const tab = event.target.closest("[data-policy-tab]");

      if (!tab || !this.contains(tab)) {
        return;
      }

      event.preventDefault();
      this.activate(tab);
    }

    handleKeydown(event) {
      const tab = event.target.closest("[data-policy-tab]");

      if (!tab || !this.contains(tab)) {
        return;
      }

      const currentIndex = this.tabs.indexOf(tab);
      let nextIndex = null;

      if (event.key === "ArrowDown" || event.key === "ArrowRight") {
        nextIndex = (currentIndex + 1) % this.tabs.length;
      } else if (event.key === "ArrowUp" || event.key === "ArrowLeft") {
        nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      } else if (event.key === "Home") {
        nextIndex = 0;
      } else if (event.key === "End") {
        nextIndex = this.tabs.length - 1;
      }

      if (nextIndex === null) {
        return;
      }

      event.preventDefault();
      this.tabs[nextIndex].focus();
      this.activate(this.tabs[nextIndex]);
    }

    handleBlockSelect(event) {
      const tab = this.tabs.find((item) => item.dataset.blockId === event.detail.blockId);

      if (tab) {
        this.activate(tab, true);
      }
    }

    activate(tab, focusPanel = false) {
      if (!tab || tab.getAttribute("aria-selected") === "true") {
        return;
      }

      this.pendingTab = tab;
      this.focusPanelAfterSwitch = focusPanel;

      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches || this.getTransitionDuration() === 0) {
        this.finishTransition();
        return;
      }

	  window.clearTimeout(this.transitionTimer);
	  this.content.classList.add("is-switching");
	  this.transitionTimer = window.setTimeout(() => {
		this.finishTransition();
	  }, this.getTransitionDuration() / 2);
    }

    finishTransition() {
      const tab = this.pendingTab;

      if (!tab) {
        return;
      }

      const panel = this.querySelector(`#${CSS.escape(tab.getAttribute("aria-controls"))}`);

      this.tabs.forEach((item) => {
        const active = item === tab;
        item.classList.toggle("is-active", active);
        item.classList.toggle("button--secondary", active);
        item.classList.toggle("button--secondary-border", !active);
        item.setAttribute("aria-selected", active.toString());
        item.tabIndex = active ? 0 : -1;
      });

      this.panels.forEach((item) => item.classList.toggle("is-active", item === panel));
      this.pendingTab = null;
      this.transitionTimer = null;
      window.requestAnimationFrame(() => this.content.classList.remove("is-switching"));

      if (this.focusPanelAfterSwitch && panel) {
        panel.focus({ preventScroll: true });
      }

      this.focusPanelAfterSwitch = false;
    }

    getTransitionDuration() {
      const value = getComputedStyle(this).getPropertyValue("--new-policy-transition-duration");

      return Number.parseFloat(value) || 0;
    }
  }

  if (!customElements.get("policy-tabs")) {
    customElements.define("policy-tabs", PolicyTabs);
  }
})();
